import React from 'react';
import type { LoyaltyPointsIconProps } from '../..';

export const DiamondMulti = ({ size }: Pick<LoyaltyPointsIconProps, 'size'>) => {
    if (size === 'sm') {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="20" viewBox="0 0 40 20" fill="none">
                <path
                    d="M30.0004 18.7C34.8052 18.7 38.7003 14.8049 38.7003 10C38.7003 5.19513 34.8052 1.3 30.0004 1.3C25.1956 1.3 21.3005 5.19513 21.3005 10C21.3005 14.8049 25.1956 18.7 30.0004 18.7Z"
                    fill="#8EADDF"
                    stroke="white"
                    strokeWidth="1.4"
                />
                <path
                    d="M19.9992 18.7C24.804 18.7 28.6991 14.8049 28.6991 10C28.6991 5.19513 24.804 1.3 19.9992 1.3C15.1943 1.3 11.2993 5.19513 11.2993 10C11.2993 14.8049 15.1943 18.7 19.9992 18.7Z"
                    fill="#4E6EA5"
                    stroke="white"
                    strokeWidth="1.4"
                />
                <path
                    d="M9.93522 18.5706C14.7043 18.5706 18.5704 14.7045 18.5704 9.93531C18.5704 5.16617 14.7043 1.3 9.93522 1.3C5.16611 1.3 1.3 5.16617 1.3 9.93531C1.3 14.7045 5.16611 18.5706 9.93522 18.5706Z"
                    fill="#253961"
                    stroke="white"
                    strokeWidth="1.4"
                />
            </svg>
        );
    }

    // Size md
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="56" height="28" viewBox="0 0 56 28" fill="none">
            <path
                d="M41.8053 26.8C48.8745 26.8 54.6051 21.0692 54.6051 14C54.6051 6.93076 48.8745 1.2 41.8053 1.2C34.7361 1.2 29.0054 6.93076 29.0054 14C29.0054 21.0692 34.7361 26.8 41.8053 26.8Z"
                fill="url(#paint0_linear_1938_153607)"
                stroke="white"
                strokeWidth="1.6"
            />
            <path
                d="M27.8055 26.8C34.8747 26.8 40.6054 21.0692 40.6054 14C40.6054 6.93076 34.8747 1.2 27.8055 1.2C20.7363 1.2 15.0057 6.93076 15.0057 14C15.0057 21.0692 20.7363 26.8 27.8055 26.8Z"
                fill="url(#paint1_linear_1938_153607)"
                stroke="white"
                strokeWidth="1.6"
            />
            <path
                d="M13.9028 26.7029C20.9184 26.7029 26.6057 21.0155 26.6057 13.9999C26.6057 6.98425 20.9184 1.29692 13.9028 1.29692C6.88724 1.29692 1.2 6.98425 1.2 13.9999C1.2 21.0155 6.88724 26.7029 13.9028 26.7029Z"
                fill="url(#paint2_linear_1938_153607)"
                stroke="white"
                strokeWidth="1.6"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_1938_153607"
                    x1="41.7082"
                    y1="5.96766"
                    x2="41.8053"
                    y2="26"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#5E83BC" />
                    <stop offset="1" stopColor="#B2CDFA" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_1938_153607"
                    x1="35.1478"
                    y1="26.7978"
                    x2="28.7841"
                    y2="3.75761"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#678DC9" />
                    <stop offset="1" stopColor="#364F81" />
                </linearGradient>
                <linearGradient
                    id="paint2_linear_1938_153607"
                    x1="13.9028"
                    y1="2.09692"
                    x2="13.9028"
                    y2="25.9029"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#1F3056" />
                    <stop offset="1" stopColor="#426194" />
                </linearGradient>
            </defs>
        </svg>
    );
};
